(() => {
  const form = document.getElementById('ds-contact');
  if (!form) return;
  const result = form.querySelector('.ds-success, .ds-contact-errors');
  if (result) result.focus();
  // Stable codes allow service links to choose a purpose without depending on translations.
  const purposes = {question: 'Choosing a product', order: 'Order or delivery', product: 'Setup or material compatibility', return: 'Return or warranty request'};
  const purpose = new URLSearchParams(location.search).get('purpose');
  if (purpose === 'creator') {
    const link = document.querySelector('[data-service-creator]');
    if (link) {
      const target = new URL(link.href, location.href);
      if (target.origin === location.origin) {
        new URLSearchParams(location.search).forEach((value, key) => {
          if (key !== 'view' && key !== 'purpose') target.searchParams.append(key, value);
        });
        target.hash = 'cp6-sample-application';
        location.replace(target.href);
        return;
      }
    }
  }
  const select = form.querySelector('[name="contact[purpose]"]');
  if (!result && select && Object.prototype.hasOwnProperty.call(purposes, purpose)) {
    select.value = purposes[purpose];
  }
})();
